import { Injectable, inject } from '@angular/core';
import { LanguageService } from './language.service';

@Injectable({ providedIn: 'root' })
export class LocaleFormatterService {
  private readonly languageService = inject(LanguageService);

  formatDate(date: string | Date): string {
    const value = typeof date === 'string' ? new Date(date) : date;
    if (Number.isNaN(value.getTime())) {
      return '-';
    }

    return value.toLocaleDateString(this.languageService.locale());
  }

  formatCurrency(value: number, currency?: string): string {
    return new Intl.NumberFormat(this.languageService.locale(), {
      style: 'currency',
      currency: currency?.trim() || 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }
}
